import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
import serviceImage from './../../assets/images/services/virtual-office.jpg';

const pageVariants = {
    initial: { scale: 0.9, opacity: 0 },
    in: { scale: 1, opacity: 1 },
    out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.5,
};

const VirtualOffice = () => {
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
        >
            <NavigationColored />
            <div style={{ marginTop: '4em' }}></div>
            <section className="service">
                <div className="container">
                    <div className="section-title" style={{ marginBottom: "50px" }}>
                        <h1>Virtual Office</h1>
                        <p>“A Business Presence Without the Overhead.”</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <p align="justify">A virtual office provides a professional business address, phone services, and administrative support—without the need for a physical office. Ideal for startups, freelancers, remote businesses, or expanding companies, it allows you to establish a credible presence in prime business locations while working from anywhere. Services typically include mail handling, call answering in your company name, and access to meeting rooms or coworking spaces when needed. A virtual office offers the flexibility and cost-efficiency of remote work while maintaining the professionalism of a traditional office setup—making it perfect for businesses looking to reduce overheads without compromising their image.</p>
                        </div>
                        <div className="col-lg-6 col-md-6 sub-services">
                            {/* <ul>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
                            </ul> */}
                            <img className="service-image" src={serviceImage} alt="service Image"/>
                        </div>
                    </div>
                </div>
            </section>
        </motion.div>
    )
}

export default VirtualOffice
